import React from 'react';
import { Box, IconButton, TextField, Typography, Paper } from '@mui/material';
import { ArrowUpward, ArrowDownward, Delete, Add } from '@mui/icons-material';

export default function PrescriptionsList({ prescriptions, onPrescriptionsChange }) {
    const addPrescription = () => {
        const newPrescription = {
            id: Date.now(),
            order: prescriptions.length + 1,
            notes: '',
        };
        onPrescriptionsChange([...prescriptions, newPrescription]);
    };

    const updatePrescription = (id, updatedFields) => {
        onPrescriptionsChange(
            prescriptions.map((pres) =>
                pres.id === id ? { ...pres, ...updatedFields } : pres
            )
        );
    };

    const deletePrescription = (id) => {
        onPrescriptionsChange(
            prescriptions
                .filter((pres) => pres.id !== id)
                .map((pres, index) => ({ ...pres, order: index + 1 }))
        );
    };

    const movePrescription = (id, direction) => {
        const index = prescriptions.findIndex((pres) => pres.id === id);
        if (index < 0) return;

        const newPrescriptions = [...prescriptions];
        const [movedItem] = newPrescriptions.splice(index, 1);
        newPrescriptions.splice(index + direction, 0, movedItem);

        onPrescriptionsChange(
            newPrescriptions.map((pres, idx) => ({ ...pres, order: idx + 1 }))
        );
    };

    return (
        <Box>
            <Typography variant="h6" sx={{ mt: 2 }}>
                Prescriptions
                <IconButton color="primary" onClick={addPrescription}>
                    <Add />
                </IconButton>
            </Typography>
            <Paper elevation={1} sx={{ p: 2 }}>
                {prescriptions
                    .sort((a, b) => a.order - b.order)
                    .map((pres) => (
                        <Box
                            key={pres.id}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 2,
                                gap: 1,
                            }}
                        >
                            <Typography>{pres.order}</Typography>
                            <TextField
                                variant="standard"
                                value={pres.notes}
                                onChange={(e) =>
                                    updatePrescription(pres.id, { notes: e.target.value })
                                }
                                fullWidth
                            />
                            {pres.order > 1 && (
                                <IconButton
                                    size="small"
                                    color="default"
                                    onClick={() => movePrescription(pres.id, -1)}
                                >
                                    <ArrowUpward />
                                </IconButton>
                            )}
                            {pres.order < prescriptions.length && (
                                <IconButton
                                    size="small"
                                    color="default"
                                    onClick={() => movePrescription(pres.id, 1)}
                                >
                                    <ArrowDownward />
                                </IconButton>
                            )}
                            <IconButton
                                size="small"
                                color="secondary"
                                onClick={() => deletePrescription(pres.id)}
                            >
                                <Delete />
                            </IconButton>
                        </Box>
                    ))}
            </Paper>
        </Box>
    );
}
